
class ModelPhoto {

    /**
     * 
     * @param {string} file 
     * @param {string} fileThumb 
     * @param {number} id 
     * @param {string} name 
     * @param {string} slug 
     */
    constructor(
        file,
        fileThumb,
        id,
        name,
        slug
    ) {
        this.file = file;
        this.fileThumb = fileThumb;
        this.id = id;
        this.name = name;
        this.slug = slug;
    }

    fromJson(json) {
        this.file = json.file;
        this.fileThumb = json.fileThumb;
        this.id = json.id;
        this.name = json.name;
        this.slug = json.slug;

        return this;
    }
}

export default ModelPhoto;
